import { combineReducers } from "redux";

import auth from "./auth";
import user from "./user";
import alert from "./alert";

const rootReducer = combineReducers({
  auth,
  user,
  alert,
});

export default rootReducer;
